/* eslint-disable no-undefined */
export var DATA_GRID_DISPLAY_NAME = "ComparisonGrid";
export var defaultPropertiesOverride = {
  role: undefined
};